// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.number-field{display:block}.number-field .mdc-text-field{width:100%}`, "",{"version":3,"sources":["webpack://./src/elements/numbers/number-field/number-field.scss"],"names":[],"mappings":"AAAA,cAAc,aAAa,CAAC,8BAA8B,UAAU","sourcesContent":[".number-field{display:block}.number-field .mdc-text-field{width:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
